import APIClient from '../../Services/AxiosClient';
import { URL_ENDPOINTS } from '../../Utils/EndPoints';

export const fetchMyLoads = async (queryPayload: any) => {
  try {
    const response: any = await APIClient({
      url: URL_ENDPOINTS?.MYLOADS?.GETALLSHIPMENTS,
      method: 'post',
      data: queryPayload,
    });
    // if (response?.status === "Success") {
    return response;
    // } else {
    //   response?.message && toast(response?.message);
    //   return null;
    // }
  } catch (err) {
    return null;
  }
};

export const fetchLoadData = async (queryPayload: any) => {
  try {
    const response: any = await APIClient({
      url: URL_ENDPOINTS?.MYLOADS?.GETSHIPMENT + `?shipmentId=${queryPayload.id}`,
      method: 'get',
    });
    // if (response?.status === "Success") {
    return response;
    // } else {
    //   response?.message && toast(response?.message);
    //   return null;
    // }
  } catch (err) {
    return null;
  }
};

export const fetchDocumentListData = async (queryPayload: any) => {
  try {
    const response: any = await APIClient({
      url: URL_ENDPOINTS?.MYLOADS?.GETDOCUMENTS 
        + `?shipmentId=${queryPayload.shipmentId}`
        +`&sourceTms=${queryPayload.sourceTms}`,
      method: 'get',
    });
    // if (response?.status === "Success") {
    return response;
    // } else {
    //   response?.message && toast(response?.message);
    //   return null;
    // }
  } catch (err) {
    return null;
  }
};

export const fetchDocumentBase64Data = async (queryPayload: any) => {
  try {
    const response: any = await APIClient({
      url: URL_ENDPOINTS?.MYLOADS?.GETDOCUMENTBASE64DATA 
        + `?shipmentId=${queryPayload.shipmentId}`
        +`&sourceTms=${queryPayload.sourceTms}`
        + `&documentNumber=${queryPayload.documentNumber}`,
      method: 'get',
    });
    // if (response?.status === "Success") {
    return response;
    // } else {
    //   response?.message && toast(response?.message);
    //   return null;
    // }
  } catch (err) {
    return null;
  }
};
